import { METRIC_FORMAT } from "modules/metrics/types"

export const getMetricUnit = (format: string) => {
  switch (format) {
    case METRIC_FORMAT.RATIO:
      return "x"
    case METRIC_FORMAT.PERCENTAGE:
      return "%"
    case METRIC_FORMAT.PRICE:
      return "$"
    case METRIC_FORMAT.NUMBER:
      return "#"
    default:
      return ""
  }
}
